import { render, staticRenderFns } from "./salearea-select.vue?vue&type=template&id=48576c5a&scoped=true"
import script from "./salearea-select.vue?vue&type=script&lang=ts"
export * from "./salearea-select.vue?vue&type=script&lang=ts"
import style0 from "./salearea-select.vue?vue&type=style&index=0&id=48576c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48576c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48576c5a')) {
      api.createRecord('48576c5a', component.options)
    } else {
      api.reload('48576c5a', component.options)
    }
    module.hot.accept("./salearea-select.vue?vue&type=template&id=48576c5a&scoped=true", function () {
      api.rerender('48576c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/salearea-select.vue"
export default component.exports